// BEAM UI primitive — Card.
// The only elevated surface: surface bg + default border + the single soft card shadow.
import React from 'react';
import { StyleSheet, View, type AccessibilityRole, type StyleProp, type ViewStyle } from 'react-native';
import { theme } from '../../theme';

type CardProps = {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  accessibilityRole?: AccessibilityRole;
  accessibilityLabel?: string;
  testID?: string;
};

export function Card({ children, style, accessibilityRole, accessibilityLabel, testID }: CardProps) {
  return (
    <View style={[styles.card, style]} accessibilityRole={accessibilityRole} accessibilityLabel={accessibilityLabel} testID={testID}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: theme.color.bg.surface,
    borderRadius: theme.radius.lg,
    borderWidth: theme.layout.hairline,
    borderColor: theme.color.border.default,
    padding: theme.spacing.lg,
    gap: theme.spacing.md,
    ...theme.shadow.card,
  },
});
